import React, { createContext, useContext, useMemo } from 'react';

const ProjectShellContext = createContext({ nestedNav: false });

export function ProjectShellProvider({ children, nestedNav = true }) {
  const value = useMemo(() => ({ nestedNav }), [nestedNav]);
  return (
    <ProjectShellContext.Provider value={value}>{children}</ProjectShellContext.Provider>
  );
}

export function useProjectShell() {
  return useContext(ProjectShellContext);
}
